import { Button, Grid, makeStyles, Typography } from '@material-ui/core';
import clsx from 'clsx';
import React, { useContext } from 'react';
import { BiTransfer } from 'react-icons/bi';
import { ConciliacaoContext } from './ConciliacaoContext';
import { ConciliacaoModal } from './modal/ConciliacaoModal';

const classStyle = makeStyles(() => ({
  header: {
    padding: '22px 21px 22px 21px',
    alignItems: 'center',
    backgroundColor: '#e2e0e0',
    justifyContent: 'space-between',
    width: '100%',
  },
  icon: {
    marginRight: '10px',
  },
  buttonImportarArquivo: {
    background: '#5890AA',
    color: '#fff',
    width: 150,
    height: 36,
    marginLeft: 10,
    borderRadius: 5,
    textTransform: 'initial',
    transition: '0.4s',
    '&:hover': {
      background: '#4E8096',
    },
  },
  buttonRegras: {
    color: '#5890AA',
    width: 170,
    height: 36,
    marginLeft: 10,
    borderRadius: 5,
    border: 'solid 1px #5890AA',
    textTransform: 'initial',
    transition: '0.4s',
    '&:hover': {
      color: '#fff',
      background: '#5890AA',
    },
  },
}));

export const Header = () => {
  const style = classStyle();
  const [, setModal] = useContext(ConciliacaoContext).modal;

  const handleOpenImportarModal = () => {
    setModal(ConciliacaoModal.importarArquivo);
  };

  const abrirRegrasAutomaticas = () => {
    setModal(ConciliacaoModal.regrasAutomaticas);
  };

  return (
    <Grid container direction="row" className={style.header}>
      <Grid>
        <Typography
          style={{
            verticalAlign: 'middle',
            display: 'inline-flex',
            alignItems: 'center',
            fontSize: '20px',
            color: '#233d4d',
            fontWeight: '600',
            lineHeight: 0.9,
          }}
        >
          <BiTransfer size={32} className={style.icon} /> Conciliação bancária
        </Typography>
      </Grid>
      <Grid
        style={{
          verticalAlign: 'middle',
          display: 'inline-flex',
          alignItems: 'center',
        }}
      >
        <Button
          className={clsx(style.buttonImportarArquivo, 'stepImportarArquivo')}
          onClick={() => handleOpenImportarModal()}
          variant="contained"
          type="button"
        >
          <Typography style={{ margin: 0 }}>Importar arquivo</Typography>
        </Button>
        <Button className={clsx(style.buttonRegras, 'stepRegrasAutomaticas')} onClick={abrirRegrasAutomaticas} variant="contained" type="button">
          <Typography style={{ margin: 0 }}>Regras automáticas</Typography>
        </Button>
      </Grid>
    </Grid>
  );
};
